import { setSelectors } from './utilities.js';

class ShopByBrand extends HTMLElement {
  
  constructor() {
    super();
    this.selectors = {};
    this._activeLetter = null;
  };

  connectedCallback() { this._initialize() };

  disconnectedCallback() { this._deinitialize() };

  _getGroups() {
    if(!this.selectors.brandsList) return [];
    return Array.from(this.selectors.brandsList.querySelectorAll('[data-brand-group]'));
  };

  _showAllGroupsAndItems() {
    this._getGroups().forEach((group) => {
      group.style.display = '';
      const items = group.querySelectorAll('[data-brand-item]');
      items.forEach((item) => {
        item.style.display = '';
      });
    });
    this._updateCount();
  };

  _applyLetterFilter(letter) {
    const groups = this._getGroups();
    const showAll = !letter || letter === 'all';
    groups.forEach((group) => {
      const groupLetter = group.getAttribute('data-brand-group');
      const shouldShow = showAll || groupLetter === letter;
      group.style.display = shouldShow ? '' : 'none';
      if(shouldShow) {
        const items = group.querySelectorAll('[data-brand-item]');
        items.forEach((item) => { item.style.display = ''; });
      };
    });
    this._updateCount();
  };

  _applySearchFilter(term) {
    const lower = term.trim().toLowerCase();
    if(!lower) {
      this._showAllGroupsAndItems();
      return;
    };

    const groups = this._getGroups();
    groups.forEach((group) => {
      let groupHasMatch = false;
      const items = group.querySelectorAll('[data-brand-item]');
      items.forEach((item) => {
        const nameText = (item.textContent || '').toLowerCase();
        const match = nameText.includes(lower);
        item.style.display = match ? '' : 'none';
        if(match) groupHasMatch = true;
      });
      group.style.display = groupHasMatch ? '' : 'none';
    });
    this._updateCount();
  };

  _updateCount() {
    if(!this.selectors.brandsList || !this.selectors.countDynamic) return;

    let visibleCount = 0;
    const groups = this._getGroups();

    groups.forEach((group) => {
      if(group.style.display === 'none') return;
      const items = group.querySelectorAll('[data-brand-item]');
      items.forEach((item) => {
        if(item.style.display === 'none') return;
        visibleCount += 1;
      });
    });

    this.selectors.countDynamic.textContent = visibleCount;
  };

  _scrollToFirstVisibleItem() {
    // Only auto-scroll on mobile (below md breakpoint)
    if(typeof window !== 'undefined') {
      const isDesktop = window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
      if(isDesktop) return;
    };

    const explicitTarget = typeof document !== 'undefined'
      ? document.getElementById('scroll-to-target')
      : null;

    const target = explicitTarget || this.selectors.brandsList;

    if(target && typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
  };
  _resetSearch = () => {
    if(this.selectors.input) {
      this.selectors.input.value = '';
      const form = this.selectors.input.closest('form');
      if(form) {
        form.classList.remove('group');
        form.removeAttribute('data-active');
      };
    };
    this._setActiveLetter(null, null);
    this._showAllGroupsAndItems();
  };

  _onInputChange = (event) => {
    if(!event || !this.selectors.input || !this.selectors.brandsList) return;
    const value = this.selectors.input.value || '';
    const term = value.trim().toLowerCase();
    const form = this.selectors.input.closest('form');
    if(form) {
      if(term.length > 0) {
        form.classList.add('group');
        form.setAttribute('data-active', 'true');
      } else {
        form.classList.remove('group');
        form.removeAttribute('data-active');
      };
    };

    if(term.length < 2) {
      this._activeLetter
        ? this._applyLetterFilter(this._activeLetter)
        : this._showAllGroupsAndItems();
      return;
    };

    this._setActiveLetter(null, null);
    this._applySearchFilter(term);
  };

  _onClearClick = (event) => {
    if(!event || !event.target || !this.selectors.clearIcon) return;
    if(!this.selectors.clearIcon.contains(event.target)) return;
    event.preventDefault();
    this._resetSearch();
  };

  _onKeypadClick = (event) => {
    if(!event || !event.target || !this.selectors.keypad) return;
    const btn = event.target.closest('[data-keypad-letter]');
    if(!btn || !this.selectors.keypad.contains(btn)) return;
    const letter = btn.getAttribute('data-keypad-letter');
    if(!letter) return;
    const nextLetter = this._activeLetter === letter ? null : letter;
    this._setActiveLetter(nextLetter, btn);
    this._filterByLetter(nextLetter);

    if(nextLetter) this._scrollToFirstVisibleItem();
  };

  _setActiveLetter(letter, activeButton) {
    this._activeLetter = letter;
    if(!this.selectors.keypad) return;
    const buttons = this.selectors.keypad.querySelectorAll('[data-keypad-letter]');
    buttons.forEach((button) => {
      letter && button === activeButton
        ? button.classList.add('active')
        : button.classList.remove('active');
    });
  };

  _filterByLetter(letter) { this._applyLetterFilter(letter); };

  _initialize() {
    this.selectors = setSelectors(this, {
      input: '[data-input]',
      clearIcon: '[data-clear-icon]',
      keypad: '[data-keypad]',
      brandsList: '[data-brands-list]',
      countDynamic: '[data-count-dynamic]'
    });
    this._updateCount();
    if(this.selectors.keypad) this.selectors.keypad.addEventListener('click', this._onKeypadClick);
    if(this.selectors.input) this.selectors.input.addEventListener('input', this._onInputChange);
    if(this.selectors.clearIcon) this.selectors.clearIcon.addEventListener('click', this._onClearClick);
  };

  _deinitialize() {
    if(this.selectors && this.selectors.keypad) this.selectors.keypad.removeEventListener('click', this._onKeypadClick);
    if(this.selectors && this.selectors.input) this.selectors.input.removeEventListener('input', this._onInputChange);
    if(this.selectors && this.selectors.clearIcon) this.selectors.clearIcon.removeEventListener('click', this._onClearClick);
  };

};

if(!customElements.get('rc-shop-by-brand')) customElements.define('rc-shop-by-brand', ShopByBrand);